import { type ComponentProps, type ComponentType, type PropsWithChildren, type ReactNode, Suspense } from 'react'
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary'

interface AsyncBoundaryProps extends PropsWithChildren {
  fallback?: ReactNode
  errorFallback?: ComponentType<FallbackProps>
}

function AsyncBoundary({ children, fallback, errorFallback }: AsyncBoundaryProps) {
  const boundaryProps: Partial<ComponentProps<typeof ErrorBoundary>> = errorFallback
    ? { FallbackComponent: errorFallback }
    : {}

  return (
    <ErrorBoundary {...boundaryProps}>
      <Suspense fallback={fallback ?? null}>
        {children}
      </Suspense>
    </ErrorBoundary>
  )
}

export default AsyncBoundary